import parseHTML from "../lib/dom/funciones/parse_html";
import swipe from "../lib/swipe";
var impacto = function () {
    Array.from(document.querySelectorAll('.impacto__contenido')).forEach(function (contenedor) {
        var lista = contenedor.querySelector('.impacto__datos');
        if (!lista) {
            return;
        }
        var actual = 0;
        var cambiar = function (i) { return function () {
            actual = i;
            lista.style.setProperty('--posicion', i.toString());
            botones.forEach(function (boton, index) {
                boton.setAttribute('aria-checked', index === i ? 'true' : 'false');
                boton.setAttribute('tabindex', index === i ? '0' : '-1');
            });
        }; };
        var datos = Array.from(lista.querySelectorAll('.impacto__dato'));
        var bolitas = parseHTML('<div class="impacto__bolitas" role="radiogroup" aria-label="Opciones disponibles"></div>');
        var botones = datos.map(function (dato, index) {
            var bolita = parseHTML("<button type=\"button\" role=\"radio\" aria-checked=\"".concat(index === 0 ? 'true' : 'false', "\" tabindex=\"").concat(index == 0 ? 0 : -1, "\" class=\"impacto__bolita\" aria-label=\"Impacto ").concat(index + 1, "\">").concat(index + 1, "</button>"));
            bolita.setAttribute('data-index', index.toString());
            bolita.setAttribute('aria-label', 'Ver dato ' + (index + 1));
            bolita.addEventListener('click', cambiar(index));
            bolitas.appendChild(bolita);
            return bolita;
        });
        swipe(lista, function () { return cambiar(actual === datos.length - 1 ? 0 : actual + 1)(); }, function () { return cambiar(actual === 0 ? datos.length - 1 : actual - 1)(); });
        bolitas.addEventListener('keydown', function (e) {
            var target = e.target;
            if (target.classList.contains('impacto__bolita')) {
                var nuevoIndex = actual;
                if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                    nuevoIndex = actual === datos.length - 1 ? 0 : actual + 1;
                    e.preventDefault();
                }
                else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                    nuevoIndex = actual === 0 ? datos.length - 1 : actual - 1;
                    e.preventDefault();
                }
                if (nuevoIndex !== actual) {
                    cambiar(nuevoIndex)();
                    botones[nuevoIndex].focus();
                }
            }
        });
        contenedor.appendChild(bolitas);
    });
};
export default impacto;
